import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { useAuthStore } from './stores/auth'
import { log } from './lib/logger'
import './assets/tokens.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)

/** Anything that escapes a component still gets logged in one place. */
app.config.errorHandler = (err, _instance, info) => {
  log.error('unhandled vue error', { err, info })
}
window.addEventListener('unhandledrejection', (e) => {
  log.error('unhandled promise rejection', { err: e.reason })
})

useAuthStore().init().catch((err) => log.error('auth init failed', { err }))

app.mount('#app')
log.info('app started', { mode: import.meta.env.MODE })
